import React from 'react'
import { Kontak } from '../page/contactpage'
import { Bagian } from '../page/footerpage'

export const KontakPage = () => {
    window.scrollTo(0, 0);
    return (
        <>
            <Kontak />
            <Bagian />
        </>
    )
}